import type { ReactNode } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AccessDenied from '../pages/AccessDenied';
import { usePermissions } from '../components/ccms-components/auth/hooks/usePermissions';
import { HELP_CONTENT_MANAGE_RIGHT } from '../components/help';
import HelpContentPage from '../pages/admin/HelpContent/index';

/**
 * Help content editor: /admin/help (?page={pageKey}&tab=tours).
 *
 * Mounted in App.tsx OUTSIDE the Admin-only /admin/* gate because the backend lets the Admin role
 * OR the Help.Content.Manage right edit help, and ProtectedRoute ANDs roles with permissions.
 */
function HelpContentGate({ children }: { children: ReactNode }) {
  const { hasRole, hasPermission } = usePermissions();
  if (!hasRole('Admin') && !hasPermission(HELP_CONTENT_MANAGE_RIGHT)) return <AccessDenied />;
  return <>{children}</>;
}

export default function AdminHelpRoutes() {
  return (
    <Routes>
      <Route index element={<MainLayout><HelpContentGate><HelpContentPage /></HelpContentGate></MainLayout>} />
      <Route path="*" element={<Navigate to="/admin/help" replace />} />
    </Routes>
  );
}
